
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-processing-agreement",
      function () {
        return require("private-next-pages/data-processing-agreement/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-processing-agreement"])
      });
    }
  